import NavBar from '@apps-common/ui-components/NavBar/NavBar.jsx';
import React, {useCallback} from 'react';
import {useAuth} from '@apps-common/auth-react';
import {useTranslation} from 'react-i18next';

import HelpMenu from './help-menu.jsx';
import {clearState} from '@explorer/blobz/util';
import {reset as resetAnalytics, trackEvent} from '@explorer/analytics';
import {withDarkTheme} from '@explorer/styles';

const TopNavBar = () => {
  const {t} = useTranslation();
  const auth = useAuth();

  const logout = useCallback(() => {
    trackEvent('Logout Button clicked');

    resetAnalytics();
    clearState();

    auth.signOut();
  }, [auth]);

  return (
    <NavBar
      title={t('global.productName')}
      user={auth.user?.claims}
      appsMenuProps={{
        exclude: 'explorer',
      }}
      secondary={<HelpMenu />}
      logout={logout}
      sx={{zIndex: 'modal'}}
    />
  );
};

export default withDarkTheme(TopNavBar);
